import { FC, useContext } from "react";
import { EcdGenerateReportContext } from "../contexts/EcdGenerateReportContext";
import CountyStatusTable from "../components/CountyStatusTable";


const CountyStatusExport: FC = () => {
  const wizardContext = useContext(EcdGenerateReportContext);
  const title = "County Status Overview";

  return (
    <div className="ecd-export__wrapper">
      <h2 className="qes-dashboard-tile__title ecd-export__head">{title}</h2>
      <CountyStatusTable tableData={wizardContext.countyStatusData} />
    </div>
  );
}

export default CountyStatusExport;